unit MainForm.Base;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls,
  WEBLib.Toast,
  App.Types;

type
  TMainBasePage = class(TForm)
    MainToast: TToast;
    MainMessageDlg: TMessageDlg;
    Whirligig: TWaitMessage;
    procedure WebFormBeforeUnload(Sender: TObject; var AMessage: string);
    procedure WebFormCreate(Sender: TObject);
  private
    { Private declarations }

    FMessagedDisplayed: Boolean;
    procedure PopStateEvent(Sender: TObject; State: JSValue);
  protected
    FMainPagePopUpForm: TForm;
    FDisplayedForm: TForm;
    function GetDisplayedPage: string; virtual;

    procedure OnFormSelfClose(Sender: TObject); virtual;
    [async]
    function ShowPopUp(AFormClass: TFormClass; OnSuccessProc: TSuccessProc = nil): TModalResult; async;
    procedure ErrorHandler(AMessage: string);
    [async]
    procedure ShowForm(AFormClass: TFormClass; AProc: TFormCreatedProc = nil; AlwaysClose: Boolean = false); async; virtual;
    function CloseDisplayedForm(const SkipValidation: Boolean = True): Boolean; virtual;
    [async]
    procedure InitForm; async; virtual;
    procedure HandlePopState(State: TJSObject; const AURL, AHash: string); virtual;
  public
    { Public declarations }
    /// <param name="AIcon">
    /// A FontAwesome icon such as 'fad fa-bug'
    /// </param>
    procedure ShowAToast(const ATitle, AMessage, AIcon: string);
    [async]
    procedure DisplayMessage(const AMessage: string; DlgType: TMsgDlgType = mtInformation); async;
    [async]
    function ConfirmationRequest(const AMessage: string; DlgType: TMsgDlgType; Buttons: TMsgDlgButtons): TModalResult; async;
    procedure ShowWaitMessage;
    procedure HideWaitMessage;

    procedure CloseMainPage; virtual;

    procedure ClosePopUp; virtual;

    class procedure DisplayPage(const AElementId: string); virtual; abstract;

    property DisplayedPage: string read GetDisplayedPage;
  protected procedure LoadDFMValues; override; end;

implementation

{$R *.dfm}

uses
  smx.webcore.Types,
  WebForm.Core;

function TMainBasePage.CloseDisplayedForm(const SkipValidation: Boolean): Boolean;
begin

  if not Assigned(FDisplayedForm) then
    Exit(True);

  if FDisplayedForm.ClassType.InheritsFrom(TCoreWebForm) then
  begin
    if SkipValidation then
      Result := True
    else
      Result := TCoreWebForm(FDisplayedForm).CanClose;

    if Result then
      TCoreWebForm(FDisplayedForm).TearDown;
  end;

  if not Result then
    Exit;

  FDisplayedForm.Free;
  FDisplayedForm := nil;
end;

procedure TMainBasePage.CloseMainPage;
begin
  CloseDisplayedForm(True);
end;

procedure TMainBasePage.ClosePopUp;
begin
  if Assigned(FMainPagePopUpForm) then
  begin
    FMainPagePopUpForm.Close;
    FMainPagePopUpForm.Free;
    FMainPagePopUpForm := Nil;
  end;
end;

function TMainBasePage.ConfirmationRequest(const AMessage: string; DlgType: TMsgDlgType; Buttons: TMsgDlgButtons)
  : TModalResult;
var
  mr: TModalResult;
begin
  mr := await(TModalResult, MainMessageDlg.ShowDialog(AMessage, DlgType, Buttons));
  Result := mr;
end;

procedure TMainBasePage.DisplayMessage(const AMessage: string; DlgType: TMsgDlgType);
var
  mr: TModalResult;
begin
  if FMessagedDisplayed then
    Exit;
  FMessagedDisplayed := True;
  mr := await(TModalResult, MainMessageDlg.ShowDialog(AMessage, DlgType, [mbOK]));
  FMessagedDisplayed := false;
end;

procedure TMainBasePage.ErrorHandler(AMessage: string);
begin
  DisplayMessage(AMessage, TMsgDlgType.mtError);
end;

function TMainBasePage.GetDisplayedPage: string;
begin
  if not Assigned(FDisplayedForm) then
    Result := 'None'
  else
    Result := FDisplayedForm.ClassName;
end;

procedure TMainBasePage.HandlePopState(State: TJSObject; const AURL, AHash: string);
begin
  // For Descendants
end;

procedure TMainBasePage.HideWaitMessage;
begin
  if Whirligig.Visible then
    Whirligig.Hide;
end;

procedure TMainBasePage.InitForm;
begin
  Application.OnPopState := PopStateEvent;
end;

procedure TMainBasePage.OnFormSelfClose(Sender: TObject);
begin
  //
end;

procedure TMainBasePage.PopStateEvent(Sender: TObject; State: JSValue);
var
  lState: TJSObject;
begin
  if not isNull(State) then
    lState := JS.toObject(State);
  HandlePopState(lState, Application.ExeName, Application.Hash);
end;

procedure TMainBasePage.ShowAToast(const ATitle, AMessage, AIcon: string);
const
  MESSAGE_TEMPLATE = '<span class="ToastMessage">%s</span>';
  MESSAGE_TITLE = '<i class="%s fa-fw fa-lg"></i> %s';
var
  lToast: TToastItem;
begin
  lToast := MainToast.Items.Add(Format(MESSAGE_TITLE, [AIcon, ATitle]), Format(MESSAGE_TEMPLATE, [AMessage]));
  lToast.Show;
end;

procedure TMainBasePage.ShowForm(AFormClass: TFormClass; AProc: TFormCreatedProc; AlwaysClose: Boolean);

  procedure AfterFormCreated(AForm: TObject);
  begin

    if AFormClass.InheritsFrom(TCoreWebForm) then
      TCoreWebForm(AForm).OnSelfClose := OnFormSelfClose;

    if AFormClass.InheritsFrom(TCoreWebForm) then
    begin
      TCoreWebForm(AForm).AfterCreated;
      HideWaitMessage;
    end;

    if Assigned(AProc) then
      AProc(AForm);

  end;

begin
  if Assigned(FDisplayedForm) and (FDisplayedForm.ClassType = AFormClass) and (AlwaysClose = false) then
    Exit;

  if not CloseDisplayedForm(True) then
    Exit;

  Application.CreateForm(AFormClass, 'MainPanel', FDisplayedForm, @AfterFormCreated);

end;

function TMainBasePage.ShowPopUp(AFormClass: TFormClass; OnSuccessProc: TSuccessProc = nil): TModalResult;
var
  lRetval: TModalResult;
begin
  if Assigned(FMainPagePopUpForm) then
  begin
    Console.error('A popup form (' + FMainPagePopUpForm.ClassName + ') is already created, so another (' +
      AFormClass.ClassName + ') can''t be created here');
    Exit;
  end;

  Result := mrClose;
  FMainPagePopUpForm := AFormClass.Create(Self);
  try
    FMainPagePopUpForm.Popup := True;
    FMainPagePopUpForm.PopupOpacity := 1;
    await(TForm, FMainPagePopUpForm.Load());
    FMainPagePopUpForm.ElementClassName := POPUP_FORM_CLASS;
    lRetval := await(TModalResult, FMainPagePopUpForm.Execute);
    if (lRetval = mrOK) and (OnSuccessProc <> nil) then
      OnSuccessProc();
    Result := lRetval;
  finally
    FMainPagePopUpForm.Free;
    FMainPagePopUpForm := nil;
  end;
end;

procedure TMainBasePage.ShowWaitMessage;
begin
  if not Whirligig.Visible then
    Whirligig.Show;
end;

procedure TMainBasePage.WebFormBeforeUnload(Sender: TObject; var AMessage: string);
begin
  //
end;

procedure TMainBasePage.WebFormCreate(Sender: TObject);
begin
  TheMainPage := Self;
  InitForm;
end;

procedure TMainBasePage.LoadDFMValues;
begin
  inherited LoadDFMValues;

  MainMessageDlg := TMessageDlg.Create(Self);
  Whirligig := TWaitMessage.Create(Self);
  MainToast := TToast.Create(Self);

  MainMessageDlg.BeforeLoadDFMValues;
  Whirligig.BeforeLoadDFMValues;
  MainToast.BeforeLoadDFMValues;
  try
    Name := 'MainBasePage';
    Width := 640;
    Height := 480;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    ElementPosition := epIgnore;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnBeforeUnload', 'WebFormBeforeUnload');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    MainMessageDlg.SetParentComponent(Self);
    MainMessageDlg.Name := 'MainMessageDlg';
    MainMessageDlg.Left := 56;
    MainMessageDlg.Top := 96;
    MainMessageDlg.Width := 24;
    MainMessageDlg.Height := 24;
    MainMessageDlg.HeightStyle := ssAuto;
    MainMessageDlg.WidthStyle := ssAuto;
    MainMessageDlg.Buttons := [];
    MainMessageDlg.Opacity := 0.200000000000000000;
    MainMessageDlg.ElementButtonClassName := 'btn btn-primary';
    MainMessageDlg.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    MainMessageDlg.ElementTitleClassName := 'text-body';
    MainMessageDlg.ElementContentClassName := 'text-body';
    Whirligig.SetParentComponent(Self);
    Whirligig.Name := 'Whirligig';
    Whirligig.Left := 48;
    Whirligig.Top := 152;
    Whirligig.Width := 24;
    Whirligig.Height := 24;
    Whirligig.HeightStyle := ssAuto;
    Whirligig.WidthStyle := ssAuto;
    Whirligig.Opacity := 0.200000000000000000;
    Whirligig.PictureURL := 'images/Whirligig.gif';
    MainToast.SetParentComponent(Self);
    MainToast.Name := 'MainToast';
    MainToast.Position := tpTopLeft;
    MainToast.Left := 48;
    MainToast.Top := 32;
  finally
    MainMessageDlg.AfterLoadDFMValues;
    Whirligig.AfterLoadDFMValues;
    MainToast.AfterLoadDFMValues;
  end;
end;

end.
